var map = {
	"./abnamro.svg": 4207,
	"./address_image.svg": 8415,
	"./aegon.svg": 9939,
	"./aegon_white.png": 2843,
	"./animated_ashutosh.png": 4054,
	"./animated_logo.svg": 4838,
	"./arch.svg": 2679,
	"./asr.png": 5633,
	"./aws.jpg": 3280,
	"./aws.png": 5175,
	"./bcs.png": 4823,
	"./blogs_image.svg": 1108,
	"./businessanalysis.svg": 2931,
	"./cloud.svg": 3382,
	"./cloud_infrastructure.svg": 5820,
	"./codeInLogo.png": 9384,
	"./cognos.png": 5836,
	"./contactMail.png": 3914,
	"./coursera_logo.png": 8857,
	"./data_science.svg": 8712,
	"./deeplearning_ai_logo.png": 774,
	"./delhivery_logo.png": 7311,
	"./developerActivity.svg": 9504,
	"./dsc_logo.png": 3979,
	"./dsmr.png": 2073,
	"./education.svg": 1803,
	"./en.png": 7042,
	"./experience.svg": 1071,
	"./experiences.svg": 5118,
	"./fb.svg": 9319,
	"./feelingProud.svg": 2677,
	"./freecopy_logo.png": 1434,
	"./fullstack.svg": 1272,
	"./gcp_logo.png": 4375,
	"./github_logo.png": 9214,
	"./googleAssistant.jpg": 3440,
	"./googleAssistant.svg": 9650,
	"./google_logo.png": 6038,
	"./grafana.png": 2771,
	"./greeter.svg": 9323,
	"./hass.svg": 9556,
	"./ibm_logo.png": 5539,
	"./iiitk_logo.png": 2837,
	"./informationanalysis.ai": 9135,
	"./informationanalysis.svg": 3125,
	"./ing.png": 8843,
	"./ing.svg": 9013,
	"./intel_logo.jpg": 1021,
	"./itil.png": 4155,
	"./jsFramework.svg": 4406,
	"./k3s.svg": 8692,
	"./k8s.png": 2875,
	"./legato_logo.png": 7147,
	"./manOnTable.svg": 3350,
	"./microsoft_logo.png": 3953,
	"./mozilla_logo.png": 9105,
	"./mqtt.svg": 5941,
	"./muffito_logo.png": 3981,
	"./nextcloud.svg": 4295,
	"./nextuLogo.jpg": 8846,
	"./nhl.png": 2969,
	"./nl.png": 5861,
	"./nodered.png": 2466,
	"./nptel_logo.png": 3862,
	"./odoo.svg": 4552,
	"./ordina.png": 3058,
	"./ou.jpg": 9659,
	"./ou2.jpg": 9409,
	"./ou2.png": 3657,
	"./p2.png": 7817,
	"./portret.jpg": 469,
	"./portret_old.jpg": 4283,
	"./programmer.svg": 2075,
	"./projects.svg": 9217,
	"./projects_image.svg": 5739,
	"./prometheus.svg": 8615,
	"./pwa.png": 7399,
	"./rdw.png": 2522,
	"./react.svg": 9624,
	"./roundcube.svg": 1942,
	"./saayaHealthLogo.png": 4123,
	"./safe.webp": 8736,
	"./stanford_logo.png": 4216,
	"./stater.png": 3380,
	"./stater.svg": 824,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./tkp.png": 5246,
	"./ubuntu.svg": 8394,
	"./ui_ux_design.svg": 7880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;